import React, { Component } from 'react';
import '../styles/BoxComponent.scss';

export default class BoxComponent extends Component {
    render(){
        return(
            <div onClick={()=> this.props.onClick(this.props.companyType)} className="landing-box" style={{backgroundImage: `url(${this.props.image})`}}>
                <div className="box-title">
                    <div>
                        <h1>{this.props.title}</h1>
                    </div>
                </div>
            </div>
        );
    }
}
